import { Component, OnInit, Input, Injector } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder } from '@angular/forms';
import { PartService, ProgramService } from '../../../phf/phf.service';
import { CgpAlertDialogService } from '../../../../shared/cgp-alert-dialog/cgp-alert-dialog.service';
import { PartGrid } from './part-grid';
import { ThroughputGrid } from './throughput-grid';
import { UploadService } from './upload-service';
import { AuthenticationService } from '../../../../auth.service';
import { ApplyReportComponent } from './apply-report/apply-report.component';
import { SelectProgramComponent } from './select-program/select-program.component';
import { CgpSnackbarService } from '../../../../shared/cgp-snackbar/cgp-snackbar.service';

@Component({
  selector: 'app-upload',
  templateUrl: './upload.component.html',
  styleUrls: ['./upload.component.scss']
})

export class UploadComponent implements OnInit {
  @Input() gridData: ThroughputGrid;

  hideFile: boolean;
  partGrid: PartGrid;
  throughputGrid: ThroughputGrid;
  applyReport: ApplyReportComponent;
  selectProgram: SelectProgramComponent;

  router: Router;
  private formBuilder: FormBuilder;
  private alertDialog: CgpAlertDialogService;
  private partService: PartService;
  private programService: ProgramService;
  private cgpSnackbarService: CgpSnackbarService;
  public uploadService: UploadService;
  public authService: AuthenticationService;
  constructor(private readonly injector: Injector) { }

  ngOnInit() {
    this.router = this.injector.get(Router);
    this.formBuilder = this.injector.get(FormBuilder);
    this.alertDialog = this.injector.get(CgpAlertDialogService);
    this.partService = this.injector.get(PartService);
    this.programService = this.injector.get(ProgramService);
    this.cgpSnackbarService = this.injector.get(CgpSnackbarService);
    this.uploadService = this.injector.get(UploadService);
    this.authService = this.injector.get(AuthenticationService);
    this.uploadService.showApplyReport.next(false);

    this.partGrid = new PartGrid(this.injector);
    this.throughputGrid = new ThroughputGrid(this.injector);
    this.applyReport = new ApplyReportComponent(this.formBuilder);
    this.selectProgram = new SelectProgramComponent(this.formBuilder, this.programService);
  }

  ngAfter() {
    this.hideFile = true;
  }

  handleApplyClose = () => {
    this.uploadService.showApplyReport.next(false);
  }

  handleProgramClose = () => {
    this.uploadService.showProgramSelect.next(false);
  }

  displaySuccessMessage = () => {
    this.cgpSnackbarService.showSnackbar({
      message: "Submission Successful!",
      duration: 2000
    });
  }

  /**
 * EventHandler to handle grid data submission for Throughput Grid
 */
  handleApplyReport = (date: any) => {
    const datetime = date;
    let payload;

    if (this.throughputGrid.data !== undefined || this.throughputGrid.data != null) {
      payload = {
        Records: this.throughputGrid.data.map((obj) => {
          obj.FileName = 'foo';
          obj.ColumnDtos = obj.TempColumns;
          delete obj.InvalidColumns
          return obj;
        }),
        ReportDate: datetime
      };
    }
    this.partService.applyThroughput(payload, false, "/Upload/UpdateThroughput", false);
    this.uploadService.showApplyReport.next(false);
    this.displaySuccessMessage();
    this.throughputGrid.refresh();
  }

  /**
   * EventHandler to handle grid data submission for Part Grid
   */
  handleApplyParts = (program: any) => {
    const prog = program;
    let payload;

    if (this.partGrid.data !== undefined || this.partGrid.data != null) {
      payload = {
        Records: this.partGrid.data.map((obj) => {
          obj.FileName = 'DefaultFileName.xlsx';
          obj.ColumnDtos = obj.TempColumns;
          delete obj.InvalidColumns
          return obj;
        }),
        ReportDate: this.applyReport.date,
        Program: prog
      }
    }
    this.partService.applyParts(payload, false, "/Upload/ApplyNewParts", false);
    this.uploadService.showProgramSelect.next(false);
    this.displaySuccessMessage();
    this.partGrid.refresh();
  }

  handleShowInvalidClose = () => {
    this.uploadService.showInvalidColumns.next(false);
  }
}
